namespace GeniuzPOS.RefundReasonReport {
    export interface ReportRefundReasonByItemForm {
        DocDate: Serenity.DateEditor;
        DocNo: Serenity.StringEditor;
        RefDate: Serenity.DateEditor;
        RefDoc: Serenity.StringEditor;
        PluCode: Serenity.StringEditor;
        ItemDesc: Serenity.StringEditor;
        Price: Serenity.DecimalEditor;
        Qty: Serenity.DecimalEditor;
        PosId: Serenity.StringEditor;
        CashierId: Serenity.StringEditor;
        AppRefund: Serenity.StringEditor;
        RefundId: Serenity.IntegerEditor;
        RefundReason: Serenity.StringEditor;
    }

    export class ReportRefundReasonByItemForm extends Serenity.PrefixedContext {
        static formKey = 'RefundReasonReport.ReportRefundReasonByItem';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ReportRefundReasonByItemForm.init)  {
                ReportRefundReasonByItemForm.init = true;

                var s = Serenity;
                var w0 = s.DateEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.IntegerEditor;

                Q.initFormType(ReportRefundReasonByItemForm, [
                    'DocDate', w0,
                    'DocNo', w1,
                    'RefDate', w0,
                    'RefDoc', w1,
                    'PluCode', w1,
                    'ItemDesc', w1,
                    'Price', w2,
                    'Qty', w2,
                    'PosId', w1,
                    'CashierId', w1,
                    'AppRefund', w1,
                    'RefundId', w3,
                    'RefundReason', w1
                ]);
            }
        }
    }
}
